// extracted by mini-css-extract-plugin
module.exports = {"skipLink":"skipLink_skipLink__0zSXZ"};